import { ComponentRef } from '@wix/editor-platform-sdk-types';
import { PlatformPrivateServices } from '../../../../PlatformPrivateServices';
import { replaceAndPreserveInnermostParentHtmlElement } from './utils';
import { BaseComponent } from '../BaseComponent';
import {
  ComponentsNamespaceErrorCode,
  createComponentsNamespaceError,
} from '../../errors';

interface ITextComponentProps {
  text: string;
}

export class TextComponent extends BaseComponent<ITextComponentProps> {
  readonly #ps: PlatformPrivateServices;
  readonly #compRef: ComponentRef;
  readonly #state: {
    text: string;
  } = {
    text: '',
  };

  public type = 'text';

  constructor(public compRef: ComponentRef, ps: PlatformPrivateServices) {
    super();

    // TODO: try to get rid of storing compref and ps
    this.#compRef = compRef;
    this.#ps = ps;

    this.#init();
  }

  #init() {
    const data = this.#ps.ds.components.data.get(this.#compRef);
    this.#state.text = data.text;
  }

  getProp<K extends keyof ITextComponentProps>(prop: K) {
    switch (prop) {
      case 'text': {
        return this.#state.text;
      }

      default: {
        return null;
      }
    }
  }

  setProp<K extends keyof ITextComponentProps>(
    prop: K,
    value: ITextComponentProps[K] | null | undefined,
  ) {
    switch (prop) {
      case 'text': {
        const dsItem = this.#ps.ds.components.data.get(this.#compRef);
        const maybeHtmlContent = dsItem.text || '';
        const newText = replaceAndPreserveInnermostParentHtmlElement(
          value ?? '',
          maybeHtmlContent,
        );
        this.#state.text = newText;
        this.#ps.ds.components.data.update(this.#compRef, {
          ...this.#ps.ds.components.data.get(this.#compRef),
          text: newText,
        });

        return;
      }

      default: {
        throw createComponentsNamespaceError(
          ComponentsNamespaceErrorCode.UnknownSetProp,
          'text components supports only "text" property',
        );
      }
    }
  }
}
